import { USER_VIP_STATUSES } from '../../constants';

const useVipUser = (accountStatuses = {}) => {
  const userVipStatuses = Object.values(USER_VIP_STATUSES);

  return Boolean(userVipStatuses.find((status) => accountStatuses[status]));
};

export default useVipUser;
